{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/embed",
	"title": "Embed",
	"category": "embed",
	"description": "Add a block that displays content pulled from other sites, like Twitter or YouTube.",
	"textdomain": "default",
	"attributes": {
		"url": {
			"type": "string",
			"role": "content"
		},
		"caption": {
			"type": "rich-text",
			"source": "rich-text",
			"selector": "figcaption",
			"role": "content"
		},
		"type": {
			"type": "string",
			"role": "content"
		},
		"providerNameSlug": {
			"type": "string",
			"role": "content"
		},
		"allowResponsive": {
			"type": "boolean",
			"default": true
		},
		"responsive": {
			"type": "boolean",
			"default": false,
			"role": "content"
		},
		"previewable": {
			"type": "boolean",
			"default": true,
			"role": "content"
		}
	},
	"supports": {
		"align": true,
		"spacing": {
			"margin": true
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-embed-editor",
	"style": "wp-block-embed"
}
